// Nombre VISIBLE del tipo de equipo. Sólo presentación: el valor persistido no cambia nunca y los
// snapshots históricos se traducen al leer, jamás se reescriben.
const ETIQUETA_TIPO = {
  MILESIGHT_WS101: "Botón de ayuda WS101",
  MOKO: "Botón de ayuda MOKO",
  MOKO_LW004PB: "Botón de ayuda MOKO",
  "Botón de pánico": "Botón de ayuda",
};

export function etiquetaTipoDispositivo(tipo) {
  return ETIQUETA_TIPO[tipo] || tipo || "Dispositivo";
}

export default etiquetaTipoDispositivo;
